// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1CIiE","visuallyhidden":"_2Qw-O","hide-text":"_1420M","center":"_1IERM","noprint":"_2e9NL","tags":"_-TqRQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-tags/styles/sports.scss
 ** module id = 345
 ** module chunks = 2
 **/